import styled from 'styled-components'



export const ProjectComponent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 31.25rem;
  gap:2em;
  margin:30px 30px;
  box-shadow: 0px 5px 28px -10px #b8a9f2;
  border-radius: 15px;
  background-color: red;
  line-height: 1.5;
  color: black;
  border-width: 1px;
  border-style: solid;
  background-color: ${({ theme }) => theme.colors.secondarytextcolor};
  & > div {
  }
  
  & > div:nth-child(odd) {
    flex: 3;
  }
  & > div:nth-child(even) {
    min-height:40%;
    padding: 20px 15px;
    & a {
      display: inline-block;
      font-size: 1.5em;
      text-decoration: none;
      margin-top: 0.75rem;
    }
  }
  & h2 {
    font-size: 2em;
    font-weight: 500;
    margin-bottom: 0.8rem;
  }
  & p {
    margin-bottom: 1.4rem;
  }
  
`;

export const StatusIndicator = styled.div`
color:red;
font-weight:500;
font-size:25px;  
`